export default {
      id: "linkedin-usage",
      viewBox: "0 0 16 17",
      url: "../../assets/" + "sprite.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }